import React, { PureComponent } from 'react';
import cn from 'classnames';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { string, object, array } from 'prop-types';

class StatisticsSubSections extends PureComponent {
  static propTypes = {
    id: string,
    type: string,
    tabs: array.isRequired,
    modifiers: object,
  };

  static defaultProps = {
    tabs: [],
    modifiers: {},
  };

  state = {
    selected: [],
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id) {
      this.setState(() => ({
        selected: [],
      }));
    }
  }

  componentDidMount() {
    const { type } = this.props;

    if (type && type.search(/subs/) > -1) {
      const selected = type.replace('subs', '').split('');

      this.setState(() => ({ selected }));
    }
  }

  isActive = (id) => {
    const { type, modifiers } = this.props;
    const { selected } = this.state;
    return modifiers.multiple ? selected.includes(id) : id === type;
  };

  handleChange = (id) => {
    const { modifiers } = this.props;
    const { selected } = this.state;

    if (modifiers && modifiers.multiple) {
      const i = selected.indexOf(id);

      if (i === -1) {
        selected.push(id);
      } else {
        selected.splice(i, 1);
      }

      this.setState(
        () => ({ selected }),
        () => {
          this.props.onChange(`${this.props.id}${selected.join('')}`);
        },
      );
    } else {
      this.props.onChange(id);
    }
  };

  render() {
    const { tabs, className } = this.props;
    return (
      <ul
        className={`${
          className ? `sub-sections list-inline ${className}` : 'sub-sections list-inline'
        }`}
      >
        {tabs.length > 0 &&
          tabs.map(({ id, title, type }) => (
            <li key={id} className="list-inline-item">
              <Button
                className={cn('sub-section-btn', { current: this.isActive(id) })}
                type="button"
                size="sm"
                color="light"
                onClick={() => this.handleChange(id)}
                outline
              >
                {title}
              </Button>
            </li>
          ))}
      </ul>
    );
  }
}

export default StatisticsSubSections;
